import i18n from "@/i18n"
import { api } from "@/lib/api/client"
import type { BaseResponse } from "@/types/api"

export interface LoginRequest {
  email: string
  password: string
}

export interface TokenPair {
  accessToken: string
  refreshToken: string
  expiresIn: number
  refreshExpiresIn: number
  tokenType: string
}

export async function login(payload: LoginRequest): Promise<TokenPair> {
  const { data } = await api.post<BaseResponse<TokenPair>>(
    "/auth/exporter/login",
    payload
  )

  if (!data.success || !data.result) {
    throw new Error(data.message ?? i18n.t("errors.loginFailed"))
  }

  return data.result
}
